import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Link from '@zenbusiness/zui/Link';
import Text from '@zenbusiness/zui/Text';

const PrivacyLink = () => (
  <Link href="https://www.zenbusiness.com/support-privacy-policy/">
    <FormattedMessage id="shopping.page.checkout.payment.privacy" />
  </Link>
);

const TermsLink = () => (
  <Link href="https://www.zenbusiness.com/support-terms/">
    <FormattedMessage id="shopping.page.checkout.payment.terms" />
  </Link>
);

function TermsAndConditions() {
  return (
    <Text size="xs">
      <FormattedMessage
        id="shopping.page.checkout.payment.agreement"
        values={{
          privacy: <PrivacyLink />,
          terms: <TermsLink />
        }}
      />
    </Text>
  );
}

export default TermsAndConditions;
